import { useEffect } from 'react';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';
import { useWalletEligibility } from '../../../hooks/use-wallet-eligibility';
import { useWalletRequirements } from '../../../hooks/use-wallet-requirements';

export const useEligibleRequirements = (walletId) => {
  const [initialized, setInitialized] = useAsyncSafeState(false);
  const [loading, setLoading] = useAsyncSafeState(false);
  const [walletToRegister, setWalletToRegister] = useAsyncSafeState(null);
  const { eligibleWallet, walletEligibility } = useWalletEligibility();

  const { consolidatedRequirements, consolidatedTerms, getRequirements, consolidatedNonDefaultTerms } = useWalletRequirements();

  useEffect(() => {
    const loadRequirements = async () => {
      setLoading(true);
      try {
        const newWalletToRegister = walletId ? walletEligibility.find((wallet) => wallet.walletId === walletId) : eligibleWallet;
        if (!newWalletToRegister) {
          setWalletToRegister(null);
          setLoading(false);
          return;
        }
        setWalletToRegister(newWalletToRegister);
        const updateIds = newWalletToRegister?.newResourceUpdates?.map((update) => update.updateId) || [];

        await getRequirements(
          newWalletToRegister.walletId,
          newWalletToRegister.currencyCode,
          newWalletToRegister.newLabelProviderIds,
          updateIds,
          newWalletToRegister.newInsuranceProviderIds,
        );
        setLoading(false);
        setInitialized(true);
      } catch {
        setLoading(false);
      }
    };

    loadRequirements();
  }, [setLoading, walletId, walletEligibility, eligibleWallet, setWalletToRegister, getRequirements, setInitialized]);

  return {
    initialized,
    loading,
    consolidatedRequirements,
    consolidatedTerms,
    consolidatedNonDefaultTerms,
    walletToRegister,
    updateWalletToRegister: setWalletToRegister,
  };
};
